import { DPChip } from "Components/DP";
import React from "react";
import useStyles from "./styles";

export interface FilterChipProps {
  label: string;
  value: string;
  onDelete: () => void;
}

export const FilterChip = ({ label, value, onDelete }: FilterChipProps) => {
  const classes = useStyles();
  return (
    <DPChip
      className={classes.root}
      key={`${label}-${value}`}
      color="primary"
      align="right"
      label={
        <div className={classes.label}>
          {label}:&nbsp;
          <div className={classes.filterValue}>{value}</div>
        </div>
      }
      onDelete={onDelete}
    />
  );
};
